import { useQuery } from '@tanstack/react-query';

import { useEcomStoreSelector } from '@/data';
import { useSelectedStore } from '@/hooks/useSelectedStore';
// import { useFulFillmentType } from '@/hooks/useFulFillmentType';
import { useSearchService } from '@/opensearch';
import { GProduct } from '@/types';

import { useIsServerSide } from './useIsServerSide';

interface IUseProductAvailability {
  isProductAvailable: boolean | undefined;
  isCheckingAvailability: boolean;
}

/**
 * Checks whether a product exists in the currently selected store's catalog.
 * The query only runs when a store is selected and the product has a path slug.
 */
export const useProductAvailability = (
  product?: Pick<GProduct, 'path_slug'> | null,
): IUseProductAvailability => {
  const { store } = useSelectedStore();
  //TODO: Add fulfillment type back in
  // const { fulfillmentType } = useFulFillmentType();
  const { customer_type } = useEcomStoreSelector(['customer_type']);
  const { getProductBySlug } = useSearchService();
  const { isServerSide } = useIsServerSide();

  const slug = product?.path_slug;
  const hasStore = !!store?.short_name;
  const enabled = hasStore && !!slug;

  const { data, isFetching, isLoading } = useQuery({
    enabled,
    queryKey: [
      'productAvailability',
      store?.short_name,
      customer_type,
      // fulfillmentType,
      slug,
    ],
    queryFn: async () => {
      const result = await getProductBySlug({ slug: slug as string });

      return { isAvailable: Boolean(result) };
    },
  });

  return {
    isProductAvailable: data?.isAvailable,
    isCheckingAvailability: isFetching || isLoading || isServerSide,
  };
};
